<button *ngIf="Pwa.promptEvent" (click)="installPwa()">
    Install TimesBapa
  </button>
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
